<template>
  <div id="app">
    <header-full 
      :active="routeName" 
      :bvc="bvc"
      :scrollPosition="scrollPosition"
      :items="links"
      @changeLang="getLang"
      @stockSynchronize="loadValues('bvc')" />

    <!-- <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut" mode="out-in" :duration="200" @after-leave="$root.$emit('triggerScroll')">-->
      <router-view :lang="lang" :bvc="bvc" @stockSynchronize="loadValues('bvc')"/>
    <!-- </transition> -->

    <footer-full :active="routeName" :lang="lang" />
  </div>
</template>

<script>
import HeaderFull from '@/components/HeaderFull.vue'
import FooterFull from '@/components/FooterFull.vue'
import links from '@/links.js'
import stockendpoint from '@/stockendpoint.js'

export default {
  components: {
    HeaderFull,
    FooterFull
  },
  data() {
    return {
      lang: 'es',
      scrollPosition: null,
      links: links,
      bvc: {
        loading: false,
        error: false,
        data: {}
      },
      local: stockendpoint
    }
  },
  computed: {
    routeName() {
      return this.$route.name
    }
  },
  methods: {
    updateScroll() {
      this.scrollPosition = window.scrollY
    },
    getLang(lang) {
      var newTitle = this.$route.meta.title[lang]
      if(newTitle) document.title = newTitle;
      this.lang = lang
    },
    loadValues(source) {
      this.bvc.loading = true
      fetch(this.local)
        .then(response => {
          // The API call was successful!
          if (response.ok) {
            return response.json();
          } else {
            throw new Error('Something went wrong');
          }
        }).then(json => {
          this.bvc.loading = false
          this.bvc.error = false
          this.bvc.data = json[source]
        }).catch(err => {
          this.bvc.loading = false
          this.bvc.error = true     
          // There was an error
          console.log('Something went wrong.', err);
        });
    }
  },
  mounted() {
    /*
      60s -> 60.000ms
      1hr -> 60m -> 3.600s -> 3.600.000ms
    */
    /*setInterval(() => {
      // ejecuta loadValues('bvc') cada 1hora
      this.loadValues('bvc')
    }, 3600000)*/
    this.loadValues('bvc')
    window.addEventListener('scroll', this.updateScroll);
  },
  destroy() {
    window.removeEventListener('scroll', this.updateScroll)
  },
  watch: {
      $route(to, from) {
        var lang = this.lang
        const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title[lang]);

        // If a route with a title was found, set the document (page) title to that value.
        if(nearestWithTitle) document.title = nearestWithTitle.meta.title[lang];
      }
  }
}
</script>
